import ApplePass from 'components/apple-pass'
import GooglePass from 'components/google-pass'
import { useAuth } from 'context/auth'
import { useDesign } from 'context/design'
import { PASS_VIEW } from 'enums'
import { ACCOUNT_TYPE } from 'enums/user'
import { useFormikContext } from 'formik'
import React from 'react'

function PassPreview({ children, view, values, variant }) {
  const formik = useFormikContext()
  const { currentUser } = useAuth()
  const { design, loading } = useDesign()

  let currentDesign = {}
  const passType = view || currentUser?.passType

  const getFullName = () => {
    let name = formik.values.firstName + ' ' + formik.values.lastName
    return name
  }

  const getDesign = (values = {}) => ({
    backgroundColor: values.backgroundColor,
    logoImage: values.logoImage,
    stripImage: values.stripImage,
    fullName: values.fullName || `${values.firstName || ''} ${values.lastName || ''}`.trim(),
    title: values.title,
    points: values.points,
    firstName: values.firstName,
    lastName: values.lastName,
    email: values.email,
    phone: values.phone,
    organisationName: values.organisationName,
    jobTitle: values.jobTitle,
    companyURL: values.companyURL,
    linkedInURL: values.linkedInURL,
    customFields: values.customFields || [],
    passCode: values.passCode || 'pa******',
  })

  if (values) currentDesign = getDesign(values)
  else if (formik?.values)
    currentDesign = getDesign({ ...formik.values, fullName: getFullName() })
  else {
    currentDesign = {
      backgroundColor: design?.backgroundColor || 'rgb(56, 41, 124)',
      logoImage: design?.logoImage,
      stripImage: design?.stripImage,
      fullName: currentUser.fullName,
    }
  }

  return (
    !loading && (
      <>
        {passType == PASS_VIEW.APPLE ? (
          <ApplePass design={currentDesign} variant={variant} />
        ) : (
          <GooglePass design={currentDesign} variant={variant} />
        )}

        {children}
      </>
    )
  )
}

export default PassPreview
